import { store, getContext } from "@wordpress/interactivity";

const { state } = store("filterable-projects", {

  state: {

    
    // Tutti i progetti che passano i filtri attivi (nessun limite di pagina)
    get filteredProjects() {
      const { projects, activeTerm, activeStato, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();

      return projects.filter((p) => {
        if (activeTerm !== 0 && !p.term_ids.includes(activeTerm)) return false;
        if (activeStato !== "" && !p.stato_progetto.includes(activeStato)) return false;
        if (q && !p.titolo.toLowerCase().includes(q)) return false;
        return true;
      });
    },

    // IDs dei progetti visibili rispettando visibleCount
    get visibleIds() {
      return new Set(
        state.filteredProjects
          .slice(0, state.visibleCount)
          .map((p) => p.id)
      );
    },

    // Getter per display della singola card — legge il context dell'elemento
    get getItemDisplay() {
      const { projectId } = getContext();
      return state.visibleIds.has(projectId) ? "block" : "none";
    },

    // Mostra il messaggio vuoto solo se nessun filtrato
    get emptyDisplay() {
      return state.filteredProjects.length === 0 ? "block" : "none";
    },

    // Mostra "mostra altro" solo se ci sono più filtrati di quelli visibili
    get loadMoreDisplay() {
      return state.filteredProjects.length > state.visibleCount ? "flex" : "none";
    },

    // Classe attiva per i bottoni categoria
    get isTermActive() {
      const { termId } = getContext();
      return state.activeTerm === termId;
    },

    // Classe attiva per i bottoni stato
    get isStatoActive() {
      const { statoValue } = getContext();
      return state.activeStato === statoValue;
    },
  },

  actions: {

    setTerm() {
      const { termId } = getContext();
      state.activeTerm = termId;
      state.visibleCount = state.perPage;
      console.log(`[filterable-projects] setTerm → termId: ${termId} | filtrati: ${state.filteredProjects.length} | visibili: ${state.visibleCount}`);
    },

    setStato() {
      const { statoValue } = getContext();
      state.activeStato = statoValue;
      state.visibleCount = state.perPage;
      state.dropdownOpen = false;
      console.log(`[filterable-projects] setStato → statoValue: "${statoValue}" | filtrati: ${state.filteredProjects.length} | visibili: ${state.visibleCount}`);
    },

    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage;
      console.log(`[filterable-projects] setSearch → query: "${state.searchQuery}" | filtrati: ${state.filteredProjects.length} | visibili: ${state.visibleCount}`);
    },

    toggleDropdown() {
      state.dropdownOpen = !state.dropdownOpen;
    },

    loadMore() {
      state.visibleCount += state.perPage;
      console.log(`[filterable-projects] loadMore → visibili ora: ${state.visibleCount} di ${state.filteredProjects.length}`);
    },
  },
});